<template>
  <v-dialog v-model="isActive" scrollable persistent>
    <v-card>
      <v-card-title class="px-4" style="text-align: center; display: block; font-size: 17px !important"> Editar informações </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-4 pb-4" style="display: flex; flex-direction: column">
        <v-text-field v-model="form.name" :disabled="loading" label="NOME" hide-details clearable outlined dense></v-text-field>

        <v-text-field
          v-model="form.phone"
          v-mask="['(##) ####-####', '(##) #####-####']"
          label="TELEFONE"
          class="pt-5"
          hide-details
          outlined
          dense
          readonly
        ></v-text-field>

        <v-text-field
          v-model="form.cpf_cnpj"
          v-mask="['###.###.###-##', '##.###.###/####-##']"
          :disabled="loading"
          label="CPF/CNPJ"
          class="pt-5"
          hide-details
          clearable
          outlined
          dense
        ></v-text-field>

        <v-text-field v-model="form.email" :disabled="loading" label="E-MAIL" class="pt-5" hide-details clearable outlined dense></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text @click="close()"> Fechar </v-btn>
        <v-spacer></v-spacer>
        <v-btn style="color: white" depressed color="#41a982" :disabled="loading || !form.name" @click="save()"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  emits: ['close', 'save'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      form: {}
    };
  },
  computed: {
    user() {
      return this.$store.getters['Auth/user'];
    }
  },
  watch: {
    isActive() {
      // eslint-disable-next-line camelcase
      const { name, email, cpf_cnpj, phone } = this.user;

      this.form = { name, email, cpf_cnpj, phone };
    }
  },
  methods: {
    save() {
      const self = this;
      self.$http
        .patch(`/web/users/${self.user.id}`, {
          name: self.form.name,
          email: self.form.email,
          cpf_cnpj: self.form.cpf_cnpj
        })
        .then(() => {
          self.$toast.success('Usuário editado', { position: 'top-right' });
          self.$store.dispatch('Auth/getUser');
          self.$emit('save');
        })
        .catch(() => {
          self.loading = false;
        });
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
